import { SmartusComponentsModule } from '@affinis/smartus-components';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-formly-FileUpload',
  imports: [
    FormlyModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    SmartusComponentsModule,
  ],
  template: `
    <div class="wrapper">
      @if (field.props?.label && field.props?.hideLabel !== true) {
        <mat-label>
          {{ field.props.label }}
          @if (field.props?.required && field.props?.hideRequiredMarker !== true) {
            <span class="mat-form-field-required-marker">*</span>
          }
        </mat-label>
      }

      <label for="file-upload" class="custom-file-upload">
        Datei Hochladen
        <input
          id="file-upload"
          type="file"
          (change)="showFileName($event)"
          (reset)="reset()"
          [formControl]="formControl"
          [formlyAttributes]="field"
        />
      </label>
      <p class="file-name">{{ fileName }}</p>

      @if (field.props?.description) {
        <mat-hint>{{ field.props.description }}</mat-hint>
      }
    </div>
  `,
  styles: [
    'input[type="file"] {display: none;}',
    '.custom-file-upload {border: 1px solid #ccc; display: inline-block; padding: 6px 12px; cursor: pointer;}',
    '.file-name{ display: inline-block; margin-left: 15px; }',
    '.wrapper{margin-bottom:10px;}',
  ],
})
export class FormlyFileUploadComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit, OnDestroy
{
  fileName = '';
  private destroy$ = new Subject<void>();

  ngOnInit() {
    // Überwache Änderungen am formControl
    this.formControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      // Wenn der Wert null oder leer ist (nach reset), lösche fileName
      if (!value) {
        this.fileName = '';
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public showFileName(event: any) {
    const name = event.target.value;
    this.fileName = name.split('\\')[2];
  }

  public reset() {
    this.fileName = '';
  }
}
